import React, { FC } from 'react';

import Banner from './Banner';
import { BANNER_FLAG_KEYS } from './Banner.types';

const PowerBiBanner: FC = () => <Banner flagKey={BANNER_FLAG_KEYS.POWERBI} />;

export default PowerBiBanner;
